var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.418 14.2l1.202.721a.5.5 0 010 .858l-8.77 5.262a1 1 0 01-1.03 0L1.05 15.78a.5.5 0 010-.858l1.202-.72 8.083 4.85 8.083-4.85zm0-4.7l1.202.721a.5.5 0 010 .858l-9.285 5.571-9.285-5.57a.5.5 0 010-.859l1.202-.72 8.083 4.85 8.083-4.85zM10.85.31L19.62 5.57a.5.5 0 010 .858L10.335 12 1.05 6.43a.5.5 0 010-.859L9.82.31a1 1 0 011.03 0zm-.514 2.022L4.222 6l6.113 3.668L16.448 6l-6.113-3.668z",
    fill: "#12C1F9"
  })));
}
export default SvgInventoryActive;